/** @format */

import React, { useState } from 'react';
import { TextField, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

// eslint-disable-next-line no-unused-vars
const CustomSearch = ({ searchText, onSearch, hideSearch, currentSearch }) => {
  const [input, setInput] = useState(searchText || '');

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      onSearch(input);
    }
  };

  const handleClear = () => {
    setInput('');
    onSearch('');
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <TextField
        size='small'
        variant='standard'
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder='Search'
        fullWidth
      />
      {input && (
        <IconButton size='small' onClick={handleClear}>
          <ClearIcon fontSize='small' />
        </IconButton>
      )}
      <IconButton size='small' onClick={() => onSearch(input)}>
        <SearchIcon fontSize='small' />
      </IconButton>
    </div>
  );
};

export default CustomSearch;
